var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradeEventArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.31 3.867) rotate(-10 62.64 56.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 103.1 0 L 103.1 74.4 L 0 74.4 Z",
    transform: "translate(11.09 18.833) rotate(-26 51.55 37.2)",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 93.2 67.616 C 93.2 67.616 107.4 -1.184 0 0.016",
    transform: "translate(19.29 24.618) rotate(-28 46.911 33.808)",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "#8a60de",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "5.886,3.886"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.4 12.7) rotate(-23 53.537 39.206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 103.1 0 L 103.1 74.4 L 0 74.4 Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.1 9.7 L 0 5.1 L 4.6 0",
    transform: "translate(99.4 71) rotate(-83 2.55 4.85)",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "#8a60de",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeEventArrowRight);
export default __webpack_public_path__ + "static/media/trade_event_arrow_right.92d234030c36c6070ddf3e491af70c7b.svg";
export { ForwardRef as ReactComponent };